import axios from 'axios';
import cookies from 'js-cookie';

import { cookieNames } from '~constants';
import { getFileInfo, imageUrl } from '~helpers/gallery';
import endpoints from '~settings/endpoints';
import { getItem } from '~helpers/storage';

const handleBeforeUpload = async (file, callback) => {
  if (file) {
    const newItem = await getFileInfo(file);
    const targetItem = {
      ...newItem,
      cancelSource: null,
    };

    uploadImage(targetItem, callback);
  }
};

const uploadImage = (item, callback) => {
  const data = new FormData();
  data.append('document', item.file);

  const cancelSource = axios.CancelToken.source();
  const headers = {
    Authorization: `Bearer ${cookies.get(cookieNames.token)}`,
  };
  const authPayload = getItem('PMS_CURRENT_USER_AUTH');
  if (authPayload && authPayload.payload && authPayload.payload.currentRoleSlug) {
    headers['Current-Role'] = authPayload.payload.currentRoleSlug;
  }
  const config = {
    cancelToken: cancelSource.token,
    onUploadProgress: () => {
      callback(null, null, false, 'UPLOADING');
    },
    headers,
    timeout: 600 * 1000,
  };
  axios
    .post(endpoints.uploadImage.url(), data, config)
    .then(response => {
      if (!response.data) {
        throw new Error('unknown error.');
      }
      const responseData = response.data;
      const itemToUpdate = {
        filename: responseData.filename,
        extension: responseData.extension,
        contentType: responseData.content_type,
        width: responseData.width,
        height: responseData.height,
        size: responseData.size,
        imageHash: responseData.image_hash,
      };
      const url = imageUrl(
        {
          ...responseData,
          source: `${responseData.filename}-${responseData.image_hash}.${responseData.extension}`,
        },
        { width: 373, height: 160 },
      );
      callback(itemToUpdate, url, false, 'DONE');
    })
    .catch(() => {
      callback(null, null, false, 'ERROR');
    });
};

export { handleBeforeUpload, uploadImage };
